/**
 * @flow
 * @relayHash bcdb84a4220d8a125876c59b965fc03e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUsernameInput = {
  userId: string,
  username: string,
  clientMutationId?: ?string,
};
export type SetUsernameMutationVariables = {|
  input: SetUsernameInput
|};
export type SetUsernameMutationResponse = {|
  +setUsername: ?{|
    +user: ?{|
      +username: ?string
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +message: ?string,
    |}>,
  |}
|};
export type SetUsernameMutation = {|
  variables: SetUsernameMutationVariables,
  response: SetUsernameMutationResponse,
|};
*/


/*
mutation SetUsernameMutation(
  $input: SetUsernameInput!
) {
  setUsername(input: $input) {
    user {
      username
      id
    }
    errors {
      code
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUsernameInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUsernameInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "CustomError",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "code",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetUsernameMutation",
  "id": null,
  "text": "mutation SetUsernameMutation(\n  $input: SetUsernameInput!\n) {\n  setUsername(input: $input) {\n    user {\n      username\n      id\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetUsernameMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUsername",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUsernamePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2
            ]
          },
          v3
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetUsernameMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUsername",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUsernamePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a95b117f38856beed2d5f098125f7fc3';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/SetUsernameMutation.graphql.js